import React, { useEffect, useState, useCallback } from 'react'

export default function useResizeObserver(ref: React.MutableRefObject<HTMLElement | null>) {
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 })

  const handleResize = useCallback((entries: Array<ResizeObserverEntry>) => {
    // Process the entries to get the new dimensions of the observed element
    if (entries && entries[0]) {
      const { width, height } = entries[0].contentRect
      setDimensions({ width, height })
    }
  }, [])

  useEffect(() => {
    const currentRef = ref.current
    if (!currentRef) return

    const resizeObserver = new ResizeObserver(handleResize)
    resizeObserver.observe(currentRef)

    return () => {
      // Clean up the observer when the component unmounts
      resizeObserver.unobserve(currentRef)
      resizeObserver.disconnect()
    }
  }, [handleResize]) // Re-run effect if handleResize changes (unlikely with useCallback)

  return dimensions
}
